import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAppSelector } from 'src/utils/hooks'
import { isFeatureFlagEnabled } from 'src/rsmCoreComponents/utils/featureFlagUtils'
import { Styles } from '../../../../types'
import {
  getCemFeatures,
  getUserInfo,
} from '../../../../store/userInfo/userInfoSlice'

const styles: Styles = {
  paddingContainer: (theme) => ({
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
    [theme.breakpoints.up('mobile')]: {
      width: '50%',
    },
    marginBottom: '2.5rem',
  }),
}

const FormAutoPopEmail = () => {
  const userInfo = useAppSelector(getUserInfo)
  const cemFeatures = useSelector(getCemFeatures)
  const { t } = useTranslation()
  const isNewSupportEnabled = isFeatureFlagEnabled(
    'Support',
    userInfo.emailAddress,
    cemFeatures,
  )

  return (
    <Box
      style={isNewSupportEnabled ? undefined : { padding: '0 1.4375rem' }}
      sx={styles.paddingContainer}>
      <Box
        sx={{
          fontFamily: 'Prelo-Black, sans-serif',
          fontSize: '1rem',
          paddingBottom: '0.5rem',
          color: '#515356',
        }}
        data-testid="Lbl_SupportForm_BusinessEmailField_Label">
        {t('BusinessEmail')}
      </Box>
      <Box
        sx={{
          wordBreak: 'break-all',
          fontFamily: 'Prelo-Book, sans-serif',
          fontSize: '1rem',
        }}
        data-testid="Lbl_SupportForm_BusinessEmailField_Value">
        {userInfo?.emailAddress}
      </Box>
    </Box>
  )
}

export default FormAutoPopEmail
